<button kendoButton size="large" style="width: 100%;" (click)="this.open()">{{'Extra Programma\'s' | translate: 'Extra Programma\'s'}}</button>
<kendo-dialog *ngIf="isEditing" title="{{'Extra Programma\'s' | translate: 'Extra Programma\'s'}}" 
    width="750px" [height]="'auto'" [maxHeight]="'85%'" (close)="this.close()">
    <div class="wgrid element-container">
        <div>{{'Omschrijving' | translate: 'Omschrijving'}}</div>
        <div class="param-header">{{'Params' | translate: 'Params'}}</div>

        @for (bp of propsService.bijzPrgs(); track bp.index) {
            <bijz-prgms-editor [onlyContents]="true" [initialValue]="bp" [class.led-even]="$even" [class.led-odd]="$odd" class="mouse-over" style="display: contents;" />
        }
    </div>
    <div class="splitter"></div>
    @for (bp of this.availableBijzPrgms(); track bp.index) {
        <bijz-prgms-editor [initialValue]="bp" [class.led-even]="$even" [class.led-odd]="$odd" class="mouse-over" [onlyDesc]="true" />
    }

</kendo-dialog>